/* lua.js generated code 0.3.0 */
var VipPrivilegesPanel = require("clover/panel/VipPrivilegesPanel")
let HomeSceneBtn = require("clover/scene/component/homescene/HomeSceneButton")
var Button = xClass("VipPrivilegesButton", HomeSceneBtn)
Button.prototype.ctor = function () {
    let self = this
    let image = "cocos/vip_privileges_icon.png"
    let text = "小游戏VIP"
    HomeSceneBtn.prototype.ctor.call(self, text, image)
}
Button.prototype.customInit = function () {
    var self = this
    self.imageNode.setScale(0.75, 0.75)
    self.imageNode.setPositionY(-5)
    self.text.setPositionY(-40)
}
Button.prototype.onCick = function () {
    var self = this
    if (self.isBusy) {
        return
    }
    DCAssist.userTrack("TencentVIP", "click_icon")
    self.isBusy = true

    function onFail() {
        Toast.make("网络出了点问题啦~", 2, function () {
            self.isBusy = false
        })
    }

    function onCancel() {
        self.isBusy = false
    }

    function onSuccess(data) {
        VipPrivilegesPanel.asyncCreate(data.data, function () {
            self.isBusy = false
        }, onFail, onCancel)
    }
    GameProxy.getInstance().getLoginInfo(function (data) {
        var http = GetWanbaVipLevelHttp.new(true)
        http.addEventListener(Events.kComplete, onSuccess)
        http.addEventListener(Events.kError, onFail)
        http.addEventListener(Events.kCancel, onCancel)
        http.load({
            qua: META.user.qua,
            openid: data.openid,
            openkey: data.openkey,
            pf: META.user.pf
        })
    })
}
module.exports = Button
